import React from 'react';
import MyCard from '../../Common/MyCard';
import AddModule from './AddModule';
import ListeModule from './ListeModule';

const Module = () => {
    return (
        <div>
            <MyCard
                titleCard="Module"
                addComponent={<AddModule />}
                content={<ListeModule /> }
            />
        </div>
    );
}

export default Module;
